<template>
  <div class="template">
    <el-table :data="list" stripe class="list">
      <el-table-column prop="name" label="文件名"> </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="small">
            <a :href="row.url" :download="row.name" target="_blank">下载</a>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { templateList } from "@/api/projectPractice/roadshow";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },

  methods: {
    // 模板列表
    getList() {
      this.$loading.show();
      templateList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.template {
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>